import debug from 'debug'
const log = debug('app')
import config from "@/config"

if (config.LOCAL_DEBUG_LOGGING) {
    log.log = console.log.bind(console);
    debug.enable('app*,store*,module*,utility*')
}
export default log